import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        header: {
            color: theme.palette.common.black,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 'bold !important',
            margin: '0',
        },
        paragraph: {
            color: theme.palette.common.black,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: theme.typography.body1.fontWeight,
            margin: '0',
        },
    }
})

export default useStyles
